<template>
  <b-row class="px-3">
    <b-col v-for="entry in contentShares" :key="entry.id" cols="12" md="3" class="px-2">
      <content-card :entry="entry" @trackShare="data => trackShareEvent(entry, data)"/>
    </b-col>
    <b-col cols="12" class="px-2">
      <b-button
        class="float-right mt-3 px-4"
        variant="outline-primary"
        :to="{ name: 'ContentShareIndex' }"
      >View All</b-button>
    </b-col>
  </b-row>
</template>

<script>
import ContentCard from '@/components/content-share/ContentCard.vue';

export default {
  props: {
    contentShares: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ContentCard,
  },
  methods: {
    trackShareEvent({ id: contentShareID }, { channel }) {
      return this.$root.captureLog({
        eventName: 'CONTENT_SHARED',
        contentShare: { id: contentShareID },
        user: { self: true },
        data: channel ? [ { key: 'channel', value: channel } ] : null,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/ContentShares.vue